import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-否",
  "use": "icon-否-usage",
  "viewBox": "0 0 160 160",
  "content": "<symbol viewBox=\"0 0 160 160\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-否\">\n<circle cx=\"80.4\" cy=\"79.6\" r=\"65.8\" stroke=\"#656565\" stroke-width=\"10\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/否.svg
// module id = uhGy
// module chunks = 26